import styled from '@emotion/styled'
import { Button } from '@vivaldis/antd-ui'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { EmptyState } from '../../../EmptyState'
import { Step, useStep } from '../../provider/StepProvider'
import emptyStateSrc from './assets/emptyStateImage.svg'

interface Props {
  onCancel: () => void
}

export const ConfirmEditingStep = ({ onCancel }: Props) => {
  const [t] = useTranslation('web_ui')

  const { step, setStep } = useStep()
  const handleConfirmButtonClick = useCallback(() => {
    setStep(Step.UploadIdDocumentStep)
  }, [setStep])

  const handleCancelButtonClick = useCallback(() => {
    onCancel()
  }, [onCancel])

  if (step !== Step.ConfirmEditingStep) {
    return null
  }

  return (
    <Base>
      <EmptyState
        title={t(
          'edit_employee_personal_information_form.steps.confirm_editing.title'
        )}
        caption={t(
          'edit_employee_personal_information_form.steps.confirm_editing.description'
        )}
        image={emptyStateSrc}
        action={
          <ActionsBase>
            <Button
              onClick={handleConfirmButtonClick}
              type="primary"
              shape="round"
              size="large"
            >
              {t(
                'edit_employee_personal_information_form.steps.confirm_editing.confirm_button'
              )}
            </Button>
            <Button
              onClick={handleCancelButtonClick}
              type="default"
              shape="round"
              size="large"
            >
              {t(
                'edit_employee_personal_information_form.steps.confirm_editing.cancel_button'
              )}
            </Button>
          </ActionsBase>
        }
      />
    </Base>
  )
}

const Base = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  top: 0;
  display: flex;
  justify-content: center;
`

const ActionsBase = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
`
